import { getEditLocation } from "../../../core/util/functions";
export const transportFeeLocation =
  "/cliring/administrativetasks/importtransportcosts";
export const getTransportFeesEditLocation = (id?: string) =>
  getEditLocation(transportFeeLocation, undefined, id);

export const editRouter = getTransportFeesEditLocation(":id?");
